import { Button, Tag } from 'antd';
import SvgIcon from 'common/components/svg-icon.component';
import { AddressTranscription } from 'config/constants/transcription.constant';
import IconMap from 'config/static/svg/icon-map.icon.svg';
import React from 'react';
import { Address } from 'store/models/user.model';
import './style.scss';
type AddressHeaderButtonProps = {
  selectedAddress?: Address;
  handleClick: () => void;
};

const AddressHeaderButton: React.FC<AddressHeaderButtonProps> = ({ selectedAddress, handleClick }) => {
  return (
    <React.Fragment>
      <div className='address-selected-header-container'>
        <Button type='text' onClick={handleClick}>
          <SvgIcon source={IconMap} name='current-address-icon' height={30} width={40} />
          <ul>
            <li>{AddressTranscription.CURRENT_ADDRESS_TEXT}</li>
            <li>
              {!selectedAddress && <Tag color='warning'>{AddressTranscription.NO_SELECTED_ADDRESS}</Tag>}
              {selectedAddress && (
                <b>
                  {selectedAddress?.street} {selectedAddress?.streetNumber}
                </b>
              )}
            </li>
          </ul>
        </Button>
      </div>
    </React.Fragment>
  );
};
export default AddressHeaderButton;
